import { Link } from "react-router-dom";
import {
  formatSubscriptionRub,
  resolveSubscriptionPresentation,
} from "../../../utils/clubSubscriptionUi";
import ss from "./subscription.module.css";

export default function ClubSubscriptionInlineBanner({
  billing,
  clubName,
  profilePath = "/manage/app/profile/account/billing",
  compact = false,
  showCta = true,
  ctaLabel,
}) {
  const pres = resolveSubscriptionPresentation(billing, clubName);
  if (pres.variant === "loading" || pres.variant === "active") return null;

  const isTrial = pres.variant === "trial";
  const icon = isTrial ? "✦" : pres.readOnly ? "!" : "⏱";
  const price = billing?.payment_amount_rub ?? billing?.monthly_price_rub;

  let text = pres.meta;
  if (!isTrial && price) {
    text = `${pres.meta} · от ${formatSubscriptionRub(price)} ₽ / мес`;
  }

  const actionLabel = ctaLabel || pres.ctaLabel;

  if (compact) {
    return (
      <div
        className={`${ss.banner} ${isTrial ? ss.bannerTrial : ""}`}
        role="status"
      >
        <div className={ss.bannerIcon} aria-hidden>
          {icon}
        </div>
        <div className={ss.bannerBody}>
          <strong className={ss.bannerTitle}>
            {isTrial ? `Демо · ${pres.progressLabel || "активно"}` : pres.title}
          </strong>
        </div>
        {showCta ? (
          <Link to={profilePath} className={ss.bannerBtn}>
            {actionLabel}
          </Link>
        ) : null}
      </div>
    );
  }

  return (
    <div
      className={`${ss.banner} ${isTrial ? ss.bannerTrial : ""}`}
      role="status"
    >
      <div className={ss.bannerIcon} aria-hidden>
        {icon}
      </div>
      <div className={ss.bannerBody}>
        <strong className={ss.bannerTitle}>
          {isTrial ? `Демо · Максимальный · ${pres.progressLabel || ""}` : pres.title}
        </strong>
        {!isTrial && text ? <p className={ss.bannerText}>{text}</p> : null}
      </div>
      {showCta ? (
        <Link to={profilePath} className={ss.bannerBtn}>
          {actionLabel}
        </Link>
      ) : null}
    </div>
  );
}
